import { PlatformLocation } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class failureModalContext {
  public message: string;
  public buttonText: string;
  public customClass?: string;
  public customImage?: string;
}

@Component({
  selector: 'app-failure-modal',
  templateUrl: './failure-modal.component.html',
  styleUrl: './failure-modal.component.scss'
})
export class FailureModalComponent {
public context: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialogRef<failureModalContext>, private location: PlatformLocation) {
      this.context = data;
      location.onPopState(() => {this.beforeDismiss();this.dialog.close();});
  }
  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  beforeDismiss(): boolean {
      return this.beforeClose();
  }
  closeDialog(result): void {
    this.beforeDismiss();
      this.dialog.close(result);
  }

  done(): void {
    this.beforeDismiss();
    this.dialog.close(true);
  }
}
